import Navbar from './Components/Navabar/Navbar';
import Hero from './Components/Hero/Hero';
import Analytics from './Components/Analytics';
import Subcripton from './Components/Subcripton';
import Card from './Components/Card';
import Footer from './Components/Footer';

function App() {
  return (
    <div>
      <Navbar></Navbar>
      <Hero></Hero>
      <Analytics/>
      <Subcripton></Subcripton>
      <Card></Card>

      <Footer></Footer>
    </div>
  );
}

export default App;
